import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineOppositeContent, TimelineSeparator,
} from '@mui/lab';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import {
 Button, Pagination, Stack, Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import { maxWidth } from '@mui/system';
import React, { useEffect, useState } from 'react';

import getAllDeploymentDetails from '../../../api/private/deployment/getAllDeploymentDetails';
import parseDateString from '../../../utils/parseDateString';

function DeploymentLogs() {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState(0);
  const [expandedLogs, setExpandedLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const fetchLogs = async () => {
    try {
      await getAllDeploymentDetails(currentPage, itemsPerPage)
        .then((response) => {
          setFilteredLogs(response.data.Data);
          setTotalPages(response.data.Pagination.PageCount);
          setTotalRows(response.data.Summary.TotalRowCount);
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error('Error fetching user activity logs:', error);
      setFilteredLogs([]);
      setTotalPages(0);
      setTotalRows(0);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [currentPage, itemsPerPage]);

  const handleExpandClick = (createdDate) => {
    setExpandedLogs((prevExpandedLogs) => {
      if (prevExpandedLogs.includes(createdDate)) {
        return prevExpandedLogs.filter((date) => date !== createdDate);
      }
      return [...prevExpandedLogs, createdDate];
    });
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (event) => {
    const newItemsPerPage = event.target.value;
    const newPageCount = Math.ceil(totalRows / newItemsPerPage);
    const newPage = Math.min(currentPage, newPageCount);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(newPage);
  };
  const thStyle = {
 border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5',
}; const tdStyle = { border: '1px solid #ddd', padding: '8px', textAlign: 'left' };
  return (
    <div style={{ marginTop: '-7px', marginLeft: '11px', marginRight: '12px' }}>
      <div className="py-2 bg-white border">
        {filteredLogs.length > 0 ? (
          <Timeline sx={{
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 'none',
              width: '110px',
              padding: 0,
            },
          }}
          >
            {filteredLogs.map((log) => {
              const jsonStartIndex = log.ReleaseNote;
              if (jsonStartIndex !== -1) {
                try {
                  const isExpanded = expandedLogs.includes(log.CreatedDate);
                  return (
                    <TimelineItem key={log.LogId}>
                      <TimelineOppositeContent style={{ padding: '2px 10px 6px 10px' }}>
                        <Stack>
                          <Typography variant="body2" style={{ color: '#6f7686' }}>
                            {parseDateString(log.CreatedDate)}
                          </Typography>
                        </Stack>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                        <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                      </TimelineSeparator>
                      <TimelineContent style={{ padding: '0 10px 6px 10px' }}>
                        <Typography>
                        { `User ${log.CreatedBy} ${log.Status} the schedule for ${parseDateString(log.StartTime)}`}
                        </Typography>
                        {isExpanded ? (
                          <>
                            <Typography
                              className="cursor-pointer text-primary-600"
                              onClick={() => handleExpandClick(log.CreatedDate)}
                            >
                              Show less
                            </Typography>
                            <pre className="whitespace-pre-wrap">
                              <div style={{ marginLeft: '48px' }}>
                                <Tooltip
                                arrow
                                placement="right-end"
                                slotProps={{ tooltip: { sx: { maxWidth: 600 } } }}
                                popp
                                            title={(
                                              <div
                                              style={{ fontSize: '12px' }}
                                              dangerouslySetInnerHTML={{ __html: log.ReleaseNote }}
                                              />
                                            )}
                                >
                                  <span style={{ cursor: 'pointer' }}>
                                Release Note
                                  </span>
                                </Tooltip>
                                {/* [ */}

                                <br />
                                {' '}
                                {' '}
                                {/* {JSON.stringify(log.ReleaseNote, null, 2)} */}
                                {' '}
                                {' '}
                                 <br />
                                 {/* ] */}

                              </div>
                              {log.Reason && (
                               <>
                                  <h3>
                                                                    Reason
                                                                    :
                                  </h3>
                                  <div style={{ marginLeft: '48px' }}>
                                                                      [
 <br />
                                                                      {' '}
                                                                      {' '}
                                                                      {JSON.stringify(log.Reason, null, 2)}
                                                                      {' '}
                                                                      {' '}
                                                                      <br />
                                                                      ]

                                  </div>
                               </>
                                  )}
                               {log.DeploymentHistories && log.DeploymentHistories.length > 0 && (
                               <h3>
                                <Button variant="text" onClick={() => setShowHistory(!showHistory)}>
                                  {showHistory ? 'Hide History' : 'Show History'}
                                </Button>
                               </h3>
)}
                                <div style={{ marginLeft: '48px' }}>

                                {' '}
                                {' '}
                               {log.DeploymentHistories && log.DeploymentHistories.length > 0 && showHistory && (
                                  <div style={{ marginTop: '16px' }}>
                                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead>
                                  <tr style={{ background: '#f5f5f5' }}>
                                  <th style={thStyle}>Status</th>
                                  <th style={thStyle}>User</th>
                                  <th style={thStyle}>Start</th>
                                  <th style={thStyle}>End</th>
                                  <th style={thStyle}>Release Note</th>
                                  <th style={thStyle}>Reason</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {log?.DeploymentHistories?.map((item) => (
                                  <tr key={item.LogId}>
                                  <td style={tdStyle}>{item.Status}</td>
                                  <td style={tdStyle}>
                                              {item.CreatedBy}
                                  </td>
                                  <td style={tdStyle}>
                                              {new Date(item.StartTime).toLocaleString('en-GB')}
                                  </td>
                                  <td style={tdStyle}>
                                              {new Date(item.EndTime).toLocaleString('en-GB')}
                                  </td>
                                  <td style={tdStyle}>{item.ReleaseNote}</td>
                                  <td style={tdStyle}>{item.Reason}</td>
                                  </tr>
                                        ))}
                                  </tbody>
                                  </table>
                                  </div>
                                  )}
                                                                  {' '}
                                {' '}
                                <br />

                                </div>
                            </pre>
                          </>
                        ) : (
                          <Typography
                            className="cursor-pointer text-primary-600"
                            onClick={() => handleExpandClick(log.CreatedDate)}
                          >
                            Show more
                          </Typography>
                        )}
                        <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                          <PersonOutlineIcon
                            style={{
                              color: '#6f7686',
                              marginRight: '5px',
                            }}
                            fontSize="small"
                          />
                          {' '}
                          user
                          {' '}
                          {log.CreatedBy}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  );
                } catch (error) {
                  console.error('Error parsing JSON:', error);
                  return null;
                }
              } else {
                return (
                  <TimelineItem key={log.LogId} className="{margin:0,padding:0}">
                    <TimelineOppositeContent style={{ padding: '0px 0px 0px 0px' }}>
                      <Stack>
                        <Typography variant="body2" style={{ color: '#6f7686' }}>
                          {parseDateString(log.CreatedDate)}
                        </Typography>
                      </Stack>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                      <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                    </TimelineSeparator>
                    <TimelineContent style={{ padding: '0 0px 0px 0px' }}>
                      {log.DeploymentMode === 'Yes' && log.ReleaseNote !== '' ? (
                        <Typography>
                          user
                          {' '}
                          {' '}
                          {log.CreatedBy}
                          {' '}
                          {' '}
                          set a schedule for
                          {' '}
                          {parseDateString(log.StartTime)}
                          {' '}
                          :
                        </Typography>
                      ) : (
                        <Typography>
                          user
                          {' '}
                          {' '}
                          {log.CreatedBy}
                          {' '}
                          {' '}
                          cancelled the schedule for
                          {' '}
                          {parseDateString(log.StartTime)}
                          {' '}
                          :
                        </Typography>
                      )}

                      <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                        <PersonOutlineIcon
                          style={{
                            color: '#6f7686',
                            marginRight: '5px',
                          }}
                          fontSize="small"
                        />
                        {' '}
                        {log.CreatedBy}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                );
              }
            })}
          </Timeline>
        ) : (
          <Typography>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex">
              <h1 className="text-2xl text-stone-500 font-gothambook">No results have been returned</h1>
            </Box>
          </Typography>
        )}
      </div>
      <div className="flex flex-col items-center gap-6 p-2 pl-4 ml-auto bg-white border rounded-lg sm:flex-row w-max">
        <FormControl sx={{ minWidth: 120 }} variant="standard" size="small" className="flex flex-row items-center">
          <Typography variant="body2" className="mr-4">Rows per page:</Typography>
          <Select
            labelId="logs-per-page"
            value={itemsPerPage}
            onChange={handleChangeItemsPerPage}
            autoWidth
            size="small"
            variant="standard"
          >
            <MenuItem value={15}>15</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
}

export default DeploymentLogs;
